import { render, staticRenderFns } from "./LinkedAccountVerificationUmb.vue?vue&type=template&id=22f14462&scoped=true"
import script from "./LinkedAccountVerificationUmb.vue?vue&type=script&lang=ts"
export * from "./LinkedAccountVerificationUmb.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f14462",
  null
  
)

export default component.exports